import { AUTHORITIES } from 'app/config/constants';
import { useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import React from 'react';
import { Redirect } from 'react-router-dom';
import HomeLoginForm from './home-login-form';

export const Home = () => {
  const account = useAppSelector(state => state.authentication.account);
  const isDriver = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.DRIVER]));

  return account && account.login ? isDriver ? <Redirect to="/truck-implement" /> : <Redirect to="/dashboards/company/truck-implements" /> : <HomeLoginForm />;
};
